import axios from "axios";
import { FormEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useScreenContext } from "../Layout";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

const converObjectToParams = (object: any) => {
  return Object.keys(object)
    .map((key) => {
      return `${key}=${encodeURIComponent(object[key])}`;
    })
    .join("&");
};

type LeadForm = {
  name: string;
  email: string;
  phone: string;
};

function Form() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [form, setForm] = useState<LeadForm>({
    name: "",
    email: "",
    phone: "",
  });
  const [screenData, setScreenData] = useScreenContext();
  const { offerType } = useParams();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get("redirectUrl");

  function validatePhoneInput(event: any) {
    let { value } = event.target;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})/, "($1) ");
    const isMobilePhone = /^[(][0-9][0-9][)][\s][9]/.test(value);

    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }

    if (isMobilePhone) {
      event.currentTarget.maxLength = 16;
      value = value.replace(/\D/g, "");
      value = value.replace(/(\d{2})(\d{1})/, "($1) $2");
      value = value.replace(/(\d{4})/, "$1-");
      value = value.replace(/(\d{4})/, "$1");
    } else {
      event.currentTarget.maxLength = 14;
      value = value.replace(/(\d{4})/, "$1-");
      value = value.replace(/(\d{4})/, "$1");
    }

    event.currentTarget.value = value;

    if (event.which === 13) {
      const htmlForm = window.document.getElementById(
        "lead"
      ) as HTMLFormElement;
      htmlForm.submit();
    }
  }

  const handleFormSubmit = (e: FormEvent) => {
    e.preventDefault();

    axios.post("https://api.12min.com/api/v1/leads/track", {
      name: form.name,
      email: form.email,
      phone: "+55" + form.phone.match(/\d/g)!.join(""),
      user_url: window.location.href,
      list_id: "78",
      interface_language: i18n.language === "br" ? "pt" : i18n.language,
      userPreferences: screenData.userPreferences,
    });

    const params = {
      hidePix: 1,
      checkoutMode: 10,
      split: 12,
      name: form.name,
      email: form.email,
      phone: "+55" + form.phone.match(/\d/g)!.join(""),
    };

    setScreenData(() => ({
      ...screenData,
      urlParams: params,
    }));

    if (redirectUrl) {
      const url =
        decodeURIComponent(redirectUrl) + "&" + converObjectToParams(params);
      window.location.href = url;
      return;
    }

    const nextPath = offerType
      ? `/${offerType}/select-challenge`
      : "/select-challenge";

    navigate(nextPath);
  };

  useEffect(() => {
    setScreenData(() => ({
      ...screenData,
      submitLabel: false,
      nextPath: "book-suggestion/1",
      progress: 100,
    }));
  }, []);

  return (
    <div>
      <h1 className="mt-10 text-2xl font-semibold leading-tight tracking-normal text-gray-900 dark:text-white md:text-4xl">
        {t("form.headline")}
      </h1>

      <div className="mt-10 text-left">
        <form
          onSubmit={handleFormSubmit}
          id="lead"
          encType="multipart/form-data"
          method="GET"
          action="/"
        >
          <div className="mb-2">
            <label className=" text-gray-700">{t("form.name_label")}</label>
            <input
              name="name"
              required
              type="text"
              className="form-input w-full"
              placeholder={t("form.name_placeholder")}
              autoFocus={true}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
          </div>
          <div className="mb-2">
            <label className=" text-gray-700">{t("form.email_label")}</label>
            <input
              required
              name="email"
              type="email"
              className="form-input w-full"
              placeholder={t("form.email_placeholder")}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
          </div>
          <div className="mb-2">
            <label className=" text-gray-700">{t("form.phone_label")}</label>
            <input
              required
              name="phone"
              type="text"
              className="form-input w-full"
              placeholder={t("form.phone_placeholder")}
              onKeyPress={
                i18n.language === "br" ? validatePhoneInput : () => {}
              }
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
            />
          </div>
          <input
            type="submit"
            style={{ visibility: "hidden", position: "absolute" }}
          />
          <button
            type="submit"
            className="text-md my-6 w-full rounded-md bg-blue-700 px-5 py-2.5 font-normal text-white hover:bg-blue-800 focus:ring-blue-300"
          >
            {t("layout.cta_continue")}
          </button>
        </form>
      </div>
      <span className="text-xs text-gray-500">{t("form.info")}</span>
    </div>
  );
}

export default Form;
